angular.module('nv.shared.modals').factory('NoteModal', NoteModal);

function NoteModal($mdDialog, Student, Note, UtilitiesService) {
  const NOTE_TEMPLATE = {
    _id: null,
    schoolId: null,
    body: null,
    category: null,
    attachments: null, // note can be attached to: a student, a support, or both.
  };

  return {
    show({ schoolId, studentId, noteId, currentUser }) {
      const Modes = {
        ASSIGN_SINGLE: 'ASSIGN_SINGLE',
        ASSIGN_MANY: 'ASSIGN_MANY',
        EDIT_SINGLE: 'EDIT_SINGLE',
      };

      let activeMode;

      // set UI-mode based on arguments
      if (_.isArray(studentId)) {
        // bulk assign a note
        activeMode = Modes.ASSIGN_MANY;
      } else if (noteId) {
        activeMode = Modes.EDIT_SINGLE;
      } else {
        activeMode = Modes.ASSIGN_SINGLE;
      }

      return $mdDialog.show({
        resolve: {
          student() {
            return activeMode === Modes.ASSIGN_MANY ? '' : Student.get({ id: studentId }).$promise;
          },
          note() {
            let note;
            if (noteId) {
              return Note.get({ id: noteId }).$promise;
            } else {
              note = new Note(angular.copy(NOTE_TEMPLATE));
              note._id = UtilitiesService.createV4Uuid();
              note.schoolId = schoolId;
            }
            return note;
          },
        },
        locals: {
          activeMode,
          studentId,
          currentUser,
        },
        disableParentScroll: true,
        template: require('./note-modal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        controller: 'NoteModalCtrl',
        controllerAs: 'ctrl',
      });
    },
  };
}
